var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_3134)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_22_3134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8 18H2.80002C2.58785 18 2.38437 17.9157 2.23434 17.7657C2.08431 17.6157 2.00002 17.4122 2.00002 17.2V1.19999C2.00002 0.987821 1.91574 0.784338 1.76571 0.634308C1.61568 0.484279 1.4122 0.399994 1.20002 0.399994C0.987851 0.399994 0.784368 0.484279 0.634339 0.634308C0.48431 0.784338 0.400024 0.987821 0.400024 1.19999L0.400024 17.2C0.400024 17.8365 0.652881 18.447 1.10297 18.8971C1.55306 19.3471 2.1635 19.6 2.80002 19.6H18.8C19.0122 19.6 19.2157 19.5157 19.3657 19.3657C19.5157 19.2157 19.6 19.0122 19.6 18.8C19.6 18.5878 19.5157 18.3843 19.3657 18.2343C19.2157 18.0843 19.0122 18 18.8 18Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4 16.4C12.6121 16.4 12.8156 16.3157 12.9657 16.1657C13.1157 16.0157 13.2 15.8122 13.2 15.6V10C13.2 9.78782 13.1157 9.58434 12.9657 9.43431C12.8156 9.28428 12.6121 9.2 12.4 9.2C12.1878 9.2 11.9843 9.28428 11.8343 9.43431C11.6843 9.58434 11.6 9.78782 11.6 10V15.6C11.6 15.8122 11.6843 16.0157 11.8343 16.1657C11.9843 16.3157 12.1878 16.4 12.4 16.4Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00007 16.4C6.21225 16.4 6.41573 16.3157 6.56576 16.1657C6.71579 16.0157 6.80007 15.8122 6.80007 15.6V10C6.80007 9.78782 6.71579 9.58434 6.56576 9.43431C6.41573 9.28428 6.21225 9.2 6.00007 9.2C5.7879 9.2 5.58442 9.28428 5.43439 9.43431C5.28436 9.58434 5.20007 9.78782 5.20007 10V15.6C5.20007 15.8122 5.28436 16.0157 5.43439 16.1657C5.58442 16.3157 5.7879 16.4 6.00007 16.4Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6 16.4C15.8122 16.4 16.0157 16.3157 16.1657 16.1657C16.3158 16.0157 16.4 15.8122 16.4 15.6V6C16.4 5.78782 16.3158 5.58434 16.1657 5.43431C16.0157 5.28428 15.8122 5.2 15.6 5.2C15.3879 5.2 15.1844 5.28428 15.0344 5.43431C14.8843 5.58434 14.8 5.78782 14.8 6V15.6C14.8 15.8122 14.8843 16.0157 15.0344 16.1657C15.1844 16.3157 15.3879 16.4 15.6 16.4Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 16.4C9.4122 16.4 9.61568 16.3157 9.76571 16.1657C9.91574 16.0157 10 15.8122 10 15.6V6C10 5.78782 9.91574 5.58434 9.76571 5.43431C9.61568 5.28428 9.4122 5.2 9.20002 5.2C8.98785 5.2 8.78437 5.28428 8.63434 5.43431C8.48431 5.58434 8.40002 5.78782 8.40002 6V15.6C8.40002 15.8122 8.48431 16.0157 8.63434 16.1657C8.78437 16.3157 8.98785 16.4 9.20002 16.4Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_3134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_22_3134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(0.400024 0.399994)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.4f8e20f620d2bf2f8cbf8047932c2ee3.svg";
export { ForwardRef as ReactComponent };